import React, { useEffect } from 'react';

const Hotjar = () => {
  useEffect(() => {
    const script = document.createElement('script');
    
    // 1. Tell Cloudflare Rocket Loader to ignore this injected script tag
    script.setAttribute('data-cfasync', 'false'); 
    
    script.innerHTML = `
            (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:5147287,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              
              // 2. Tell Cloudflare Rocket Loader to ignore the Hotjar source file
              r.setAttribute('data-cfasync', 'false'); 
              
              a.appendChild(r);
              })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `;
    document.head.appendChild(script);

    return () => {
      // Cleanup if necessary
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default Hotjar;